import React, { useMemo, useEffect, useState } from "react";

import { getImageUrl } from "utils/imageGallery/index";

import HeaderImage from "assets/images/nzCaseStudy/header.png";
import FooterImage from "assets/images/nzCaseStudy/footerNZ.png";

import "../styles.css";

const NZReportPDFPageImages = ({ imagesType = "", images = [], allImages = [] }) => {
    const [imagesWithFixedUrl, setImagesWithFixedUrl] = useState([]);
    const [imgIsWide, setImgIsWide] = useState(false);

    const filteredImages = useMemo(
        () =>
            allImages
                .filter((image) => images.includes(image.id))
                .map(({ name, ...image }) => ({ ...image, name: name ? name : "Noname Image" })),
        [allImages, images]
    );

    useEffect(() => {
        const fetchImages = async () => {
            const updatedImages = await Promise.all(
                filteredImages.map(async (img) => {
                    const fileUrl = await getImageUrl(img.fileUrl);
                    return { ...img, fileUrl };
                })
            );
            setImagesWithFixedUrl(updatedImages);
        };

        fetchImages();
    }, [filteredImages]);

    useEffect(() => {
        // Ensures image always takes up the full div and is cropped accordingly
        imagesWithFixedUrl.forEach((image) => {
            const img = new Image();
            img.src = image.fileUrl;
            img.onload = function () {
                // Access naturalWidth and naturalHeight for original dimensions
                const naturalWidth = this.naturalWidth;
                const naturalHeight = this.naturalHeight;

                setImgIsWide((prev) => ({
                    ...prev,
                    // [image.id]: (naturalWidth > naturalHeight + 300),
                    [image.id]: naturalHeight / naturalWidth < 0.5,
                }));
            };
        });
    }, [imagesWithFixedUrl]);

    return (
        <div className="bodyNZPDF">
            <img src={HeaderImage} alt="header" />
            <div
                className="pageContainerNZPDF"
                style={{
                    flex: 1,
                    background: "#fff",
                    margin: "0 20px",
                    padding: "25px 0",
                    maxWidth: "775px",
                }}
            >
                <div
                    style={{
                        background: "#93BB49",
                        padding: "15px 0",
                        textAlign: "center",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "26px",
                            fontWeight: "800",
                            color: "#fff",
                            textTransform: "uppercase",
                        }}
                    >
                        PHOTO GALLERY <span style={{ color: "#626261" }}>- {imagesType.toUpperCase()}</span>
                    </h1>
                </div>
                <div className="imageGridNZPDF">
                    {imagesWithFixedUrl.map((img) => (
                        <div key={img.id} className="imageContainerNZPDF">
                            <div className="centeredCroppedImage">
                                <img src={`${img.fileUrl}`} className={imgIsWide[img.id] ? "wideImage" : "tallImage"} />
                            </div>
                            <div className="notesContainerNZPDF">
                                <span>{img.notes.slice(0, 100)}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <img src={FooterImage} alt="footer" />
        </div>
    );
};

export default NZReportPDFPageImages;
